import * as React from 'react';
import { Checkbox, Input, Textarea, UIText3, useDeviceType } from '@cian/ui-kit';
import { debounce } from '@cian/newbuilding-utils';
import { useDispatch, useSelector } from 'react-redux';
import { UiKitContextProvider } from '@cian/ui-kit/context';

import { ANSWER_MAX_LENGTH } from '../../constants/reviews';
import { setQuestionText } from '../../actions/newQuestion';
import { getQuestionText, getIsAnonymous, getName } from '../../selectors/newQuestion';
import { NewQuestionContent } from '../../components/NewQuestionContent';
import { setIsAnonymous } from '../../actions/newQuestion/isAnonymousActions';
import { getFirstName } from '../../selectors/user';
import { setName } from '../../actions/newQuestion/nameActions';

export const QuestionContainer = () => {
  const dispatch = useDispatch();
  const initialValue = useSelector(getQuestionText);
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const isAnonymous = useSelector(getIsAnonymous);
  const initialName = useSelector(getFirstName);
  const name = useSelector(getName) || initialName;

  const [value, setValue] = React.useState(initialValue || '');
  const [counter, setCounter] = React.useState(initialValue.length);

  const setQuestionTextDebounced = debounce(200, nextValue => dispatch(setQuestionText(nextValue)));

  const onChange = React.useCallback(
    (_event: React.ChangeEvent<HTMLTextAreaElement>, nextValue: string) => {
      const counter = nextValue.length;
      if (counter <= ANSWER_MAX_LENGTH) {
        setCounter(nextValue.length);
        setValue(nextValue);
        setQuestionTextDebounced(nextValue);
      }
    },
    [setValue, setQuestionTextDebounced],
  );

  const onAnonymousChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      dispatch(setIsAnonymous(value));
    },
    [dispatch],
  );

  const onNameChange = React.useCallback(
    /* oxlint-disable-next-line typescript/no-unused-vars, typescript/no-explicit-any */
    (e: React.ChangeEvent<HTMLInputElement>, _value: any) => {
      dispatch(setName(e.currentTarget.value));
    },
    [dispatch],
  );

  return (
    <NewQuestionContent
      name={
        <Input
          size="M"
          width="100%"
          inline={true}
          onChange={onNameChange}
          placeholder="Например, Иван"
          value={name}
          disabled={!!initialName}
        />
      }
      question={
        <>
          <Textarea
            onChange={onChange}
            value={value}
            minRows={8}
            maxRows={8}
            width="100%"
            size={isMobile ? 'M' : 'XS'}
          />
          <UIText3 color="gray40_100">{`${counter}/${ANSWER_MAX_LENGTH}`}</UIText3>
        </>
      }
      anonymous={
        <UiKitContextProvider useStaticDeviceType={true} deviceType="desktop">
          <Checkbox label="Анонимный вопрос" checked={isAnonymous} onChange={onAnonymousChange} />
        </UiKitContextProvider>
      }
    />
  );
};
